export default {"src":"/_next/static/media/preloader.cdf31726.svg","height":161,"width":161};